<template>
  <transition name="modal">
    <portal to="destination">
      <div class="modal-backdrop z-20" v-show="show" @click.self="$emit('close')">
        <div class="relative modal flex justify-center text-center flex-col text-xm px-12">
          <button class="absolute pin-t pin-r outline-none m-6 z-40" @click="$emit('close')">
            <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
          </button>
          <div>
            <p class="font-bold mt-4">
              Вы уверены, что хотите изменить
              <br />регистрацию с
              <span class="text-brand-light">{{newdate}} {{prevPlace}}</span>
              <br />на
              <span class="text-brand-light">{{nextDate}} {{event.place}}</span>
            </p>
            <p v-if="isPlayersCountDecrease" class="mt-4">
              В заведении <span class="text-brand-light">{{event.place}}</span> максимальное количество игроков в команде {{event.max_team_players}}. При переносе заявки, число участников изменится.
            </p>
          </div>
          <div class="flex justify-between my-5">
            <button
              @click.self="$emit('close')"
              class="inline-block justify-center w-full whitespace-no-wrap hover-up font-bold bg-white border border-main-text text-main-text rounded-full px-6 py-3 outline-none"
            >Отменить</button>
            <button @click.self="changeDay"
              class="outline-none ml-4 rounded-full whitespace-no-wrap w-full hover-up flex flex-row items-center justify-center bg-brand-yellow px-8 text-main-text font-semibold"
            >Изменить</button>
          </div>
        </div>
      </div>
    </portal>
  </transition>
</template>

<script>
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';
import client from '@/clients/player';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['user_in_line', 'event', 'events'],
  name: 'ChangeGameDay',
  data() {
    return {
      ext: '',
      show: true,
    };
  },
  computed: {
    prevDate() {
      const currentEvent = this.events.find(item => item.uuid === this.user_in_line.games_event_day_id);
      const date = format(currentEvent.played_at, 'DD MMMM', { locale: ru });
      return date;
    },
    prevPlace() {
      const currentEvent = this.events.find(item => item.uuid === this.user_in_line.games_event_day_id);
      return currentEvent.place;
    },
    nextDate() {
      const dates = [];
      dates.push(format(this.event.played_at, 'DD MMMM', { locale: ru }));
      return dates[0];
    },

    isPlayersCountDecrease() {
      return this.events.find(item => item.uuid === this.user_in_line.games_event_day_id).max_team_players - this.event.max_team_players > 0;
    },
  },
  methods: {
    changeDay() {
      client.patch(`applications/${this.user_in_line.id}/change?event_day_id=${this.event.uuid}`, { confirmed: this.isPlayersCountDecrease })
        .then(({ data }) => {
          this.updateUserApplication(data);
          this.$emit('close_upd');
        });
    },
    dismiss() {
      document.body.style.overflow = 'auto';
      this.$emit('close');
      return this.show === false;
    },
    ...mapActions([
      'updateUserApplication']),
  },
  created() {
    document.body.style.overflow = 'hidden';
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss();
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
      this.dismiss();
    });
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  padding: 2rem;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.modal {
  width: 500px;
  height: 13rem;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3), 0 5px 15px rgba(0, 0, 0, 0.07);
  border-radius: 10px;
  background-color: #ffffff;
}
</style>
